import { render, staticRenderFns } from "./PrecoDeCusto.vue?vue&type=template&id=2c87cf13&scoped=true"
import script from "./PrecoDeCusto.vue?vue&type=script&lang=js"
export * from "./PrecoDeCusto.vue?vue&type=script&lang=js"
import style0 from "./PrecoDeCusto.vue?vue&type=style&index=0&id=2c87cf13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87cf13",
  null
  
)

export default component.exports